export const DESKTOP_RELEASE_FALLBACK_DATE = '2026-05-23'

export const DESKTOP_RELEASE_BASE = 'https://downloads.martini.film/desktop-releases/latest'

export const DESKTOP_DOWNLOADS = {
  macArm: `${DESKTOP_RELEASE_BASE}/Martini-mac-arm64.dmg`,
  windows: `${DESKTOP_RELEASE_BASE}/Martini-win-x64.exe`,
} as const

export const DESKTOP_FILE_SIZES = {
  macArm: '~110 MB',
  windows: '~95 MB',
} as const

export type DesktopPlatform = 'macArm' | 'windows'

export const DESKTOP_PLATFORM_LABELS: Record<DesktopPlatform, string> = {
  macArm: 'Mac (Apple Silicon)',
  windows: 'Windows',
}
